import type { ObservationDeleteButtonProps } from "./observation-delete-button.type";

import { useTranslation } from "react-i18next";

import { useAuthorization } from "@/modules/authorization";
import { ObservationDeleteSidePanel } from "@/modules/observation/observation-delete-side-panel";
import { useSidePanel } from "@/modules/side-panel";

export const useObservationDeleteButton = ({
  observation,
  loading,
  disabled,
  onSuccess,
  invalidateKeys,
}: ObservationDeleteButtonProps) => {
  const { t } = useTranslation();
  const { openSidePanel, closeSidePanel } = useSidePanel();
  const { canDeleteItem } = useAuthorization();

  const hideButton = !canDeleteItem(observation);

  const onDeleteSuccess = () => {
    closeSidePanel();
    onSuccess?.();
  };

  const onDeleteClick = () => {
    openSidePanel({
      title: t("observation:delete.sidePanel.title"),
      component: (
        <ObservationDeleteSidePanel
          observation={observation}
          options={{ onSuccess: onDeleteSuccess, invalidateKeys }}
        />
      ),
    });
  };

  return {
    loading,
    disabled,
    hideButton,
    onDeleteClick,
  };
};
